export const PAGE_OPEN = "page_open"
export const STEP_COMPLETED = "step_completed"
export const SWITCHING_TO_MOBILE = "switching_to_mobile"
export const SWITCHED_TO_MOBILE = "switched_to_mobile"
export const FACE_CAPTURE_STARTED = "face_capture_started"
export const FACE_CAPTURE_NATIVE = "face_capture_native"
export const FACE_CAPTURED = "face_captured"
export const FACE_CAPTURE_RETRY = "face_capture_retry"
export const DOCUMENT_CAPTURE_STARTED = "document_capture_started"
export const DOCUMENT_CAPTURE_NATIVE = "document_capture_native"
export const DOCUMENT_CHANGED_CAMERA = "document_changed_camera"
export const DOCUMENT_CAPTURED = "document_captured"
export const DOCUMENT_CAPTURE_RETRY = "document_capture_retry"
export const LIVENESS_TEST_STARTED = "liveness_test_started"
export const LIVENESS_TEST_RETRY = "liveness_test_retry"
export const DOCUMENT_CAPTURE_ERROR = 'document_capture_error';
export const LANDSCAPE_CAPTURE_1 = "landscape_capture_1";
export const LANDSCAPE_CAPTURE_3 = "landscape_capture_3";
export const LANDSCAPE_CAPTURE_5 = "landscape_capture_5";
export const LOCKED_CAPTURE_1 = "locked_capture_1";
export const LOCKED_CAPTURE_3 = "locked_capture_3";
export const LOCKED_CAPTURE_5 = "locked_capture_5";
export const PORTRAIT_CAPTURE_1 = "portrait_capture_1";
export const PORTRAIT_CAPTURE_3 = "portrait_capture_3";
export const PORTRAIT_CAPTURE_5 = "portrait_capture_5";
export const MID = "mid";
export const NID = "nid";
export const MPASS = "mpass";
export const NPASS = "npass";


export const FL3D_ERROR = 'fl3d_error';
export const RETRY_CAMERA_INIT = 'retry_camera_init';

const loggingFunctions = [];

export function subscribeLoggingFunction(fn) {
  loggingFunctions.push(fn);
}

export function logEvent(name, params) {
  loggingFunctions.forEach(fn => fn(name, params));
}
